import { useQuery } from "react-query";
import { gql } from "graphql-request";
import { IPreTransaction } from "@pbm/transactions/contracts/pre-transaction";
import { IFilteredColumn } from "@funcional/react-table-ui";
import { usePbm2Url } from "@common/hooks/usePbm2Url";
import { CursorPaginated } from "@types";

export interface PreTransactionArgsFilterInput {
  afterDate?: string;
  beforeDate?: string;
  customerCode?: string[];
  id?: number[];
  legacyAuthorizationId?: string[];
  legacyProcessedAt?: string;
  legacySequenceId?: string[];
  programCode?: string[];
  status?: string[];
  type?: string[];
  storeCode?: string[];
}
interface UsePreTransactionsOptions {
  before?: string;
  after?: string;
  first?: number;
  last?: number;
  filter?: PreTransactionArgsFilterInput;
  gridFilters?: IFilteredColumn[];
}

export function usePreTransactions(
  options: UsePreTransactionsOptions | undefined = {}
) {
  const { request } = usePbm2Url();
  options.first = options.first || 10;
  if (options.gridFilters) {
    const filter: PreTransactionArgsFilterInput = options.filter || {};

    options.gridFilters.forEach((filteredColumn: any) => {
      if (filteredColumn.id === "id")
        filter.id = [Number(filteredColumn.value)];
      if (filteredColumn.id === "type") filter.type = [filteredColumn.value];
      if (filteredColumn.id === "status")
        filter.status = [filteredColumn.value];
      if (filteredColumn.id === "customerCode")
        filter.customerCode = [filteredColumn.value];
      if (filteredColumn.id === "storeCode")
        filter.storeCode = [filteredColumn.value];
      if (filteredColumn.id === "legacyIdentifiers.authorizationId")
        filter.legacyAuthorizationId = [filteredColumn.value];
      if (filteredColumn.id === "legacyIdentifiers.sequenceId")
        filter.legacySequenceId = [filteredColumn.value];
      if (filteredColumn.id === "after") options.after = filteredColumn.value;
      if (filteredColumn.id === "items")
        filter.programCode = filteredColumn.value;
    });

    options.filter = filter;
  }
  return useQuery<CursorPaginated<IPreTransaction>, Error>(
    "preTransactions:" + JSON.stringify(options),
    async () => {
      const { Transactional_preTransactions } = await request(
        gql`
          query preTransactions(
            $before: String
            $after: String
            $first: Int
            $last: Int
            $filter: Transactional_PreTransactionArgsFilterInput
          ) {
            Transactional_preTransactions(
              before: $before
              after: $after
              first: $first
              last: $last
              filter: $filter
            ) {
              pageInfo {
                hasNextPage
                hasPreviousPage
                startCursor
                endCursor
                pageCount
                totalCount
              }
              edges {
                node {
                  id
                  storeCode
                  customerCode
                  beneficiary {
                    id
                  }
                  grossValue
                  discountValue
                  netValue
                  type
                  status
                  statusCode
                  statusMessage
                  origin
                  createdAt
                  items {
                    programCode
                  }
                  legacyIdentifiers {
                    authorizationId
                    sequenceId
                    processedAt
                  }
                }
              }
            }
          }
        `,
        options
      );

      return Transactional_preTransactions as CursorPaginated<IPreTransaction>;
    }
  );
}
